export default "__VITE_ASSET__B6EFwyI4__"